import Link from 'next/link';
import styled from '@emotion/styled';
import { Component as ComponentContainer } from '@styles/layout';
import { PlainLinkStyles } from '@styles/common';
import { ThemeProps } from '@theme/base';
import { HomePageTripTypes, Page } from '@model/common';
import { SectionTitle, SectionTitleSizes } from '@components/common/section-title';
import { TextMarkdown } from '@components/common/description';
import { TripTypeGridItem, TripTypesGrid } from '@components/trip-types/TripTypesGrid';
import { useI18NextContext } from '@components/hooks';
import { TestId } from '@components/test-ids';

const Description = styled(TextMarkdown)(({ theme }: ThemeProps) => ({
  marginBottom: theme.custom.spacing.medium
}));

export const TripTypeTilesContainer = ({ data }) => {
  const t = useI18NextContext();
  const images = data?.map(({ images }) => images[0]);

  const getGridItemsData: () => Array<TripTypeGridItem> = () =>
    HomePageTripTypes.map(({ tripType, icon }) => ({
      renderLink: (children: JSX.Element) => (
        <Link
          prefetch={false}
          href={`${Page.TRIP_TYPES}/[tripType]`}
          as={`${Page.TRIP_TYPES}/${tripType}`}
          passHref
          style={PlainLinkStyles}
        >
          {children}
        </Link>
      ),
      title: t(tripType),
      icon
    }));

  return (
    <ComponentContainer data-testid={TestId.homepageTripTypesComponent.main}>
      <SectionTitle heading={t('trip-types__heading')} size={SectionTitleSizes.LARGE} />
      <Description description={t('trip-types__description')} />
      <TripTypesGrid tripTypes={getGridItemsData()} images={images} />
    </ComponentContainer>
  );
};
